/* global axios */
import ApiClient from '../ApiClient';

// Customer lifecycle is part of the canonical account-scoped Teletel API:
// /api/v1/accounts/:account_id/teletel/lifecycle. This differs from older
// Teletel modules that are mounted below /teletel/api/v1.
class CustomerLifecycleAPI extends ApiClient {
  constructor() {
    super('lifecycle', { accountScoped: true });
  }

  baseUrl() {
    return `${super.baseUrl()}/teletel`;
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(enabled) {
    return axios.patch(`${this.url}/settings`, { enabled });
  }

  getStages({ includeArchived = false } = {}) {
    return axios.get(`${this.url}/stages`, {
      params: { include_archived: includeArchived },
    });
  }

  createStage(stage) {
    return axios.post(`${this.url}/stages`, stage);
  }

  updateStage(id, stage) {
    return axios.patch(`${this.url}/stages/${id}`, stage);
  }

  archiveStage(id) {
    return axios.delete(`${this.url}/stages/${id}`);
  }

  reorderStages(stageIds) {
    return axios.patch(`${this.url}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }

  getContact(contactId) {
    return axios.get(`${this.url}/contacts/${contactId}`);
  }

  getTransitions(contactId, params = {}) {
    return axios.get(`${this.url}/contacts/${contactId}/transitions`, {
      params,
    });
  }

  transitionContact(contactId, transition) {
    return axios.post(
      `${this.url}/contacts/${contactId}/transitions`,
      transition
    );
  }

  clearContact(contactId, transition) {
    return axios.delete(`${this.url}/contacts/${contactId}`, {
      data: transition,
    });
  }

  bulkTransition(payload) {
    return axios.post(`${this.url}/contacts/bulk-transition`, payload);
  }

  getReport(report, params = {}) {
    return axios.get(`${this.url}/reports/${report}`, { params });
  }

  exportReport(params = {}) {
    return axios.get(`${this.url}/reports/export.csv`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new CustomerLifecycleAPI();
